import React from 'react'
import { t } from 'i18next'
import { FormatMoney } from 'Utils/functions'
import CostMarginVisibility from 'Components/CostMarginVisibility/CostMarginVisibility'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'

export const FooterTextValue = ({ value, type, seeMargenProd, rounded }) => {
  switch (type) {
    case t('SELL_BY_PROD_T.DISCOUNT_LABEL'):
      return (
        <div data-testid="container-discount-amount">
          <p
            data-testid="text-discount-amount-label"
            style={{ color: '#FF2A40' }}>
            {type}
          </p>
          <p data-testid="text-discount-amount" style={{ color: '#FF2A40' }}>
            ${rounded ? FormatMoney(value, true, 2) : FormatMoney(value)}
          </p>
        </div>
      )
    case t('SELL_BY_PROD_T.FOOTER_CATALOG.ITBMS_TYPE'):
      return (
        <div data-testid="container-itbms-amount">
          <p data-testid="text-itbms-amount-label">{type}</p>
          <ToolTipAmount amount={value} type="itbms" />
        </div>
      )
    case t('SELL_BY_PROD_T.FOOTER_CATALOG.TOTAL_TYPE'):
      return (
        <div data-testid="container-total-amount">
          <p data-testid="text-total-amount-label">{type}</p>
          <ToolTipAmount amount={value} type="total" />
        </div>
      )
    case t('SELL_BY_PROD_T.MARGIN_LABEL'):
      return (
        <div>
          <p>{type}</p>
          <CostMarginVisibility
            seeMargenProd={seeMargenProd}
            simple
            isMargin
            margin={value}
            secondaryColor
          />
        </div>
      )
    default:
      return (
        <div
          data-testid={`container-${type
            ?.replace(' ', '-')
            .toLowerCase()}-amount`}>
          <p
            data-testid={`text-${type
              ?.replace(' ', '-')
              .toLowerCase()}-amount-label`}>
            {type}
          </p>
          <p
            data-testid={`text-${type
              ?.replace(' ', '-')
              .toLowerCase()}-amount`}>
            $
            {rounded && value
              ? FormatMoney(value, true, 2)
              : value
              ? FormatMoney(value)
              : '0.00'}
          </p>
        </div>
      )
  }
}
